import fakeData from './fakeData.json';

// these data are generated using faker
// TODO: OPS-24932 to be removed later once real API is available
export interface LedgerActivityReportEntry {
    id: string;
    accounted: string;
    ownerId?: string;
    serviceItemId: string;
    accountingCategoryId?: string;
    billId?: string;
    tax: number;
    amount: number;
}

export const mockData = fakeData satisfies LedgerActivityReportEntry[];
